<template>
  <div class="cd_feedback">
    <h3>Like what we are doing?</h3>
    <p>We would love to hear from you.</p>
    <a href="#" class="btn btn-info btn-lg">
      Website Feedback <font-awesome-icon icon="comment-dots" />
    </a>
  </div>
</template>

<script>
  export default {
    name: 'FooterFeedback'
  }
</script>
